module.exports = __webpack_public_path__ + "static/media/cevrron-right.df6d6d5a.svg";